import { render, staticRenderFns } from "./CustomerInvoicesView.vue?vue&type=template&id=beb48c94&lang=pug"
import script from "./CustomerInvoicesView.vue?vue&type=script&lang=ts"
export * from "./CustomerInvoicesView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('beb48c94')) {
      api.createRecord('beb48c94', component.options)
    } else {
      api.reload('beb48c94', component.options)
    }
    module.hot.accept("./CustomerInvoicesView.vue?vue&type=template&id=beb48c94&lang=pug", function () {
      api.rerender('beb48c94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/billing/CustomerInvoices/CustomerInvoicesView.vue"
export default component.exports